/* eslint-disable */
import { useEffect, useState } from 'react';
import BaseModal from '@/Components/Modals/BaseModal/BaseModal';
import { Button } from '@/Components/ui/button';
import MultiCascaderTree from '@/Components/MultiCascaderTree/MultiCascaderTree';
import { notificationServices } from '@/Services';
import {
	collectSelectedByType,
	drillDownBuilders,
} from './createOrdersDrillDownConfig';

const preselect = (nodes, variantIds) => (nodes || []).map((node) => ({
	...node,
	select: node?.type === 'variant' && variantIds.includes(node?.variantId)
		? 1
		: node?.select,
	children: preselect(node?.children, variantIds),
}));

const ProductDrillDownModal = ({
	open,
	onClose,
	productList,
	selectedIds = [],
	onApply,
}) => {
	const [tree, setTree] = useState([]);
	const [loading, setLoading] = useState(false);
	const builder = drillDownBuilders.products;

	useEffect(() => {
		if (!open) return undefined;
		let cancelled = false;
		setLoading(true);
		(async () => {
			try {
				const data = await builder.fetchData({ productList });
				const built = builder.buildTree(data) || [];
				if (cancelled) return;
				setTree(preselect(built, selectedIds));
			} catch (error) {
				console.error('Error building product tree:', error);
				notificationServices.generateNotification({
					type: 'error',
					message: 'Could not load the product list. Please retry.',
				});
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [open]);

	const handleApply = () => {
		const picked = collectSelectedByType(tree)?.variant || [];
		const variantIds = picked
			.map((id) => Number(String(id).split('_')[1]))
			.filter((id) => !Number.isNaN(id));
		onApply?.(variantIds);
		onClose?.();
	};

	const renderBtns = () => (
		<div className='flex w-full items-center justify-end gap-2'>
			<Button variant='outline' onClick={onClose}>Cancel</Button>
			<Button
				className='bg-amber-400 px-6 font-semibold text-gray-900 hover:bg-amber-500'
				onClick={handleApply}
			>
				Add Selected Products
			</Button>
		</div>
	);

	return (
		<BaseModal
			open={open}
			handleClose={onClose}
			renderBtns={renderBtns}
			width='100vw'
			height='50rem'
			heading='Select Products'
		>
			<div className='h-full overflow-auto bg-gray-50/60 p-3'>
				{loading ? (
					<div className='flex h-full items-center justify-center text-[14px] text-gray-500'>
						Loading products…
					</div>
				) : (
					<div className='overflow-hidden rounded-xl border border-gray-200 bg-white p-2 shadow-sm'>
						<MultiCascaderTree
							inputState={tree}
							setInputState={setTree}
							widthPercentage={95}
							headers={builder?.headers || []}
						/>
					</div>
				)}
			</div>
		</BaseModal>
	);
};

export default ProductDrillDownModal;
